import { render, staticRenderFns } from "./ProtestsChangeStatusModal.vue?vue&type=template&id=04efd860&scoped=true&"
import script from "./ProtestsChangeStatusModal.vue?vue&type=script&lang=js&"
export * from "./ProtestsChangeStatusModal.vue?vue&type=script&lang=js&"
import style0 from "./ProtestsChangeStatusModal.vue?vue&type=style&index=0&id=04efd860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04efd860",
  null
  
)

export default component.exports